import { Context, Layer, type Cause, type Effect, type Scope } from "effect";
import type { ResourceTabFocusFailure, ResourceTabKind } from "./resource-focus-model.ts";

export class ResourceTabFocusIo extends Context.Service<ResourceTabFocusIo, {
  readonly frame: Effect.Effect<unknown, ResourceTabFocusFailure>;
  readonly focus: (target: HTMLElement, kind: ResourceTabKind) => Effect.Effect<unknown, ResourceTabFocusFailure>;
}>()("workerstation/frontend/ResourceTabFocusIo") {}
export const ResourceTabFocusIoTest = (io: typeof ResourceTabFocusIo.Service) => Layer.succeed(ResourceTabFocusIo, io);
export interface ResourceTabFocusSession {
  readonly focus: (target: HTMLElement | null, kind: unknown) => Effect.Effect<void>;
}
export class ResourceTabFocusSessions extends Context.Service<ResourceTabFocusSessions, {
  readonly open: (isCurrent: (target: HTMLElement, kind: ResourceTabKind) => unknown) => Effect.Effect<ResourceTabFocusSession, never, Scope.Scope>;
  readonly failures: Effect.Effect<readonly Cause.Cause<ResourceTabFocusFailure>[]>;
}>()("workerstation/frontend/ResourceTabFocusSessions") {}
